<!-- <div class="container">
    <mat-table matSort [dataSource]="dataSource" class="pro-partner-table">

        <ng-container matColumnDef="position">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
            <td mat-cell *matCellDef="let element"> {{element.position}} </td>
        </ng-container>
        
        <ng-container matColumnDef="year">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> YEAR </th>
            <td mat-cell *matCellDef="let element"> {{element.year}} </td>
        </ng-container>
        
        <ng-container matColumnDef="quarter">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> QUARTER </th>
            <td mat-cell *matCellDef="let element"> {{element.quarter}} </td>
        </ng-container>
        
        <ng-container matColumnDef="distributionYear">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> DISTRIBUTION YEAR </th>
            <td mat-cell *matCellDef="let element"> {{element.distributionYear}} </td>
        </ng-container>
        
        <ng-container matColumnDef="distributionQuarter">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> DISTRIBUTION QUARTER </th>
            <td mat-cell *matCellDef="let element"> {{element.distributionQuarter}} </td>
        </ng-container>
        
        <ng-container matColumnDef="statementRecipientId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> STATEMENT RECIPIENT ID </th>
            <td mat-cell *matCellDef="let element"> {{element.statementRecipientId}} </td>
        </ng-container>
        
        <ng-container matColumnDef="statementRecipientName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> STATEMENT RECIPIENT NAME </th>
            <td mat-cell *matCellDef="let element"> {{element.statementRecipientName}} </td>
        </ng-container>
        
        <ng-container matColumnDef="partyId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PARTY ID </th>
            <td mat-cell *matCellDef="let element"> {{element.partyId}} </td>
        </ng-container>
        
        <ng-container matColumnDef="partyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PARTY NAME </th>
            <td mat-cell *matCellDef="let element"> {{element.partyName}} </td>
        </ng-container>
        
        <ng-container matColumnDef="legalEarnerPartyId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> LEGAL EARNER PARTY ID </th>
            <td mat-cell *matCellDef="let element"> {{element.legalEarnerPartyId}} </td>
        </ng-container>
        
        <ng-container matColumnDef="legalEarnerPartyName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> LEGAL EARNER PARTY NAME </th>
            <td mat-cell *matCellDef="let element"> {{element.legalEarnerPartyName}} </td>
        </ng-container>
        
        <ng-container matColumnDef="performanceSource">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE SOURCE </th>
            <td mat-cell *matCellDef="let element"> {{element.performanceSource}} </td>
        </ng-container>
        
        <ng-container matColumnDef="musicUserGenre">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> MUSIC USER GENRE </th>
            <td mat-cell *matCellDef="let element"> {{element.musicUserGenre}} </td>
        </ng-container>
        
        <ng-container matColumnDef="musicUser">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> MUSIC USER </th>
            <td mat-cell *matCellDef="let element"> {{element.musicUser}} </td>
        </ng-container>
        
        <ng-container matColumnDef="networkService">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> NETWORK SERVICE </th>
            <td mat-cell *matCellDef="let element"> {{element.networkService}} </td>
        </ng-container>
        
        <ng-container matColumnDef="performanceStartDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE START DATE </th>
            <td mat-cell *matCellDef="let element"> {{element.performanceStartDate}} </td>
        </ng-container>
        
        <ng-container matColumnDef="performanceEndDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE END DATE </th>
            <td mat-cell *matCellDef="let element"> {{element.performanceEndDate}} </td>
        </ng-container>
        
        <ng-container matColumnDef="serveyType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> SURVEY TYPE </th>
            <td mat-cell *matCellDef="let element"> {{element.serveyType}} </td>
        </ng-container>
        
        <ng-container matColumnDef="dayPartCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> DAY PART CODE </th>
            <td mat-cell *matCellDef="let element"> {{element.dayPartCode}} </td>
        </ng-container>
        
        <ng-container matColumnDef="show">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> SHOW </th>
            <td mat-cell *matCellDef="let element"> {{element.show?.name}} </td>
        </ng-container>
        
        <ng-container matColumnDef="episodeName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> EPISODE NAME </th>
            <td mat-cell *matCellDef="let element"> {{element.episodeName}} </td>
        </ng-container>
        
        <ng-container matColumnDef="workId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> WORK ID </th>
            <td mat-cell *matCellDef="let element"> {{element.workId}} </td>
        </ng-container>
        
        <ng-container matColumnDef="workTitle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> WORK TITLE </th>
            <td mat-cell *matCellDef="let element"> {{element.workTitle}} </td>
        </ng-container>
        
        <ng-container matColumnDef="allocationPercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ALLOCATION PERCENTAGE </th>
            <td mat-cell *matCellDef="let element"> {{element.allocationPercentage}} </td>
        </ng-container>
        
        <ng-container matColumnDef="classificationCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> CLASSIFICATION CODE </th>
            <td mat-cell *matCellDef="let element"> {{element.classificationCode}} </td>
        </ng-container>
        
        <ng-container matColumnDef="numberOfPlays">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> NUMBER OF PLAYS </th>
            <td mat-cell *matCellDef="let element"> {{element.numberOfPlays}} </td>
        </ng-container>
        
        <ng-container matColumnDef="performanceType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE TYPE </th>
            <td mat-cell *matCellDef="let element"> {{element.performanceType}} </td>
        </ng-container>
        
        <ng-container matColumnDef="duration">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> DURATION </th>
            <td mat-cell *matCellDef="let element"> {{element.duration}} </td>
        </ng-container>
        
        <ng-container matColumnDef="performingArtist">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMING ARTIST </th>
            <td mat-cell *matCellDef="let element"> {{element.performingArtist}} </td>
        </ng-container>
        
        <ng-container matColumnDef="composerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> COMPOSER NAME </th>
            <td mat-cell *matCellDef="let element"> {{element.composerName}} </td>
        </ng-container>
        
        <ng-container matColumnDef="eeShare">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> EE SHARE </th>
            <td mat-cell *matCellDef="let element"> {{element.eeShare}} </td>
        </ng-container>
        
        <ng-container matColumnDef="credits">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> CREDITS </th>
            <td mat-cell *matCellDef="let element"> {{element.credits}} </td>
        </ng-container>
        
        <ng-container matColumnDef="royalty">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ROYALTY </th>
            <td mat-cell *matCellDef="let element"> {{element.royalty}} </td>
        </ng-container>
        
        <ng-container matColumnDef="premiumCredits">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PREMIUM CREDITS </th>
            <td mat-cell *matCellDef="let element"> {{element.premiumCredits}} </td>
        </ng-container>
        
        <ng-container matColumnDef="premiumRoyalty">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PREMIUM ROYALTY </th>
            <td mat-cell *matCellDef="let element"> {{element.premiumRoyalty}} </td>
        </ng-container>

        <ng-container matColumnDef="adjustmentIndicator">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ADJUSTMENT INDICATOR </th>
            <td mat-cell *matCellDef="let element"> {{element.adjustmentIndicator}} </td>
        </ng-container>
        
        <ng-container matColumnDef="adjustmentReasonCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ADJUSTMENT REASON CODE </th>
            <td mat-cell *matCellDef="let element"> {{element.adjustmentReasonCode}} </td>
        </ng-container>
        
        <ng-container matColumnDef="originalDistributionDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ORIGINAL DISTRIBUTION DATE </th>
            <td mat-cell *matCellDef="let element"> {{element.originalDistributionDate}} </td>
        </ng-container>
        
        <ng-container matColumnDef="roleType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ROLE TYPE </th>
            <td mat-cell *matCellDef="let element"> {{element.roleType}} </td>
        </ng-container>
        
        <ng-container matColumnDef="typeOfRight">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> TYPE OF RIGHT </th>
            <td mat-cell *matCellDef="let element"> {{element.typeOfRight}} </td>
        </ng-container>
        
        <ng-container matColumnDef="terriotry">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> TERRITORY </th>
            <td mat-cell *matCellDef="let element"> {{element.terriotry}} </td>
        </ng-container>
        
        <ng-container matColumnDef="licensor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> LICENSOR </th>
            <td mat-cell *matCellDef="let element"> {{element.licensor}} </td>
        </ng-container>
        
        <ng-container matColumnDef="programCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PROGRAM CODE </th>
            <td mat-cell *matCellDef="let element"> {{element.programCode}} </td>
        </ng-container>
        
        <ng-container matColumnDef="performanceQuarter">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE QUARTER </th>
            <td mat-cell *matCellDef="let element"> {{element.performanceQuarter}} </td>
        </ng-container>
        
        <ng-container matColumnDef="countryName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> COUNTRY NAME </th>
            <td mat-cell *matCellDef="let element"> {{element.countryName}} </td>
        </ng-container>
        
        <ng-container matColumnDef="fileType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> FILE TYPE </th>
            <td mat-cell *matCellDef="let element"> {{element.fileType}} </td>
        </ng-container>
        
        <ng-container matColumnDef="licensorCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> LICENSOR CODE </th>
            <td mat-cell *matCellDef="let element"> {{element.licensorCode}} </td>
        </ng-container>
        
        <ng-container matColumnDef="revenueClassCode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> REVENUE CLASS CODE </th>
            <td mat-cell *matCellDef="let element"> {{element.revenueClassCode}} </td>
        </ng-container>
        
        <ng-container matColumnDef="revenueClassDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> REVENUE CLASS DESCRIPTION </th>
            <td mat-cell *matCellDef="let element"> {{element.revenueClassDescription}} </td>
        </ng-container>
        
        <ng-container matColumnDef="adjustentDistributionDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ADJUSTMENT DISTRIBUTION DATE </th>
            <td mat-cell *matCellDef="let element"> {{element.adjustentDistributionDate}} </td>
        </ng-container>
        
        <ng-container matColumnDef="currentActivityAmt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> CURRENT ACTIVITY AMOUNT </th>
            <td mat-cell *matCellDef="let element"> {{element.currentActivityAmt}} </td>
        </ng-container>
        
        <ng-container matColumnDef="hitSongBonus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> HIT SONG BONUS </th>
            <td mat-cell *matCellDef="let element"> {{element.hitSongBonus}} </td>
        </ng-container>
        
        <ng-container matColumnDef="standardsBonus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> STANDARDS BONUS </th>
            <td mat-cell *matCellDef="let element"> {{element.standardsBonus}} </td>
        </ng-container>
        
        <ng-container matColumnDef="foreignSocietyAdjustment">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> FOREIGN SOCIETY ADJUSTMENT </th>
            <td mat-cell *matCellDef="let element"> {{element.foreignSocietyAdjustment}} </td>
        </ng-container>
        
        <ng-container matColumnDef="perfDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE DATE </th>
            <td mat-cell *matCellDef="let element"> {{element.perfDate}} </td>
        </ng-container>
        
        <ng-container matColumnDef="wOrP">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> W OR D </th>
            <td mat-cell *matCellDef="let element"> {{element.wOrP}} </td>
        </ng-container>
        
        <ng-container matColumnDef="showName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> SHOW NAME </th>
            <td mat-cell *matCellDef="let element"> {{element.showName}} </td>
        </ng-container>
        
        <ng-container matColumnDef="paymentType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PAYMENT TYPE </th>
            <td mat-cell *matCellDef="let element"> {{element.paymentType}} </td>
        </ng-container>
        
        <ng-container matColumnDef="chart">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> CHART </th>
            <td mat-cell *matCellDef="let element"> {{element.chart}} </td>
        </ng-container>
        
        <ng-container matColumnDef="payNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PAY NUMBER </th>
            <td mat-cell *matCellDef="let element"> {{element.payNumber}} </td>
        </ng-container>
        
        <ng-container matColumnDef="synd">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> SYND </th>
            <td mat-cell *matCellDef="let element"> {{element.synd}} </td>
        </ng-container>
        
        <ng-container matColumnDef="strip">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> STRIP </th>
            <td mat-cell *matCellDef="let element"> {{element.strip}} </td>
        </ng-container>
        
        <ng-container matColumnDef="performance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> PERFORMANCE </th>
            <td mat-cell *matCellDef="let element"> {{element.performance}} </td>
        </ng-container>
        
        <ng-container matColumnDef="occur">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> OCCUR </th>
            <td mat-cell *matCellDef="let element"> {{element.occur}} </td>
        </ng-container>
        
        <ng-container matColumnDef="socidetyAbbrv">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> SOCIETY ABBRV </th>
            <td mat-cell *matCellDef="let element"> {{element.socidetyAbbrv}} </td>
        </ng-container>
        
        <ng-container matColumnDef="societyCountry">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> SOCIETY COUNTRY </th>
            <td mat-cell *matCellDef="let element"> {{element.societyCountry}} </td>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
</div> -->

<!-- STANDARD HTML TABLE APPROACH - START -->
<div class="container">

    <div *ngIf="allPartnerPros.length < 1 && loading == false" class="pro-loader">No Results for {{proType}} {{proYear}} {{proQuarter}}</div>

    <div *ngIf="loading" class="pro-loader">
        <app-loader color="#50e3c2"></app-loader>
    </div>

    <div class="table-container" #scrollContainer (scroll)="onScroll($event)">
        <table class="pro-table" *ngIf="allPartnerPros.length > 0">
            <tr class="header-row">
                <th *ngFor="let col of columns" class="column-headers" (click)="sortTable(col)">{{col}}</th>
            </tr>
            <tr *ngFor="let row of allPartnerPros; let i = index" class="data-row">
                <td class="position-cell">{{(tablePage - 1) * tablePageSize + i + 1}}</td>
                <td>{{row.year}}</td>
                <td>{{row.quarter}}</td>
                <td>{{row.distributionYear}}</td>
                <td>{{row.distributionQuarter}}</td>
                <td>{{row.statementRecipientId}}</td>
                <td>{{row.statementRecipientName}}</td>
                <td>{{row.partyId}}</td>
                <td>{{row.partyName}}</td>
                <td>{{row.legalEarnerPartyId}}</td>
                <td>{{row.legalEarnerPartyName}}</td>
                <td>{{row.performanceSource}}</td>
                <td>{{row.musicUserGenre}}</td>
                <td>{{row.musicUser}}</td>
                <td>{{row.networkService}}</td>
                <td>{{row.performanceStartDate | date}}</td>
                <td>{{row.performanceEndDate | date}}</td>
                <td>{{row.surveyType}}</td>
                <td>{{row.dayPartCode}}</td>
                <td>{{row.show?.name}}</td> <!-- Assuming 'show' has a 'name' property -->
                <td>{{row.episodeName}}</td>
                <td>{{row.workId}}</td>
                <td>{{row.workTitle}}</td>
                <td>{{row.allocationPercentage}}</td>
                <td>{{row.classificationCode}}</td>
                <td>{{row.numberOfPlays}}</td>
                <td>{{row.performanceType}}</td>
                <td>{{row.duration}}</td>
                <td>{{row.performingArtist}}</td>
                <td>{{row.composerName}}</td>
                <td>{{row.eeShare}}</td>
                <td>{{row.credits}}</td>
                <td>{{row.royalty}}</td>
                <td>{{row.premiumCredits}}</td>
                <td>{{row.premiumRoyalty}}</td>
                <td>{{row.adjustmentIndicator}}</td>
                <td>{{row.adjustmentReasonCode}}</td>
                <td>{{row.originalDistributionDate | date}}</td>
                <td>{{row.roleType}}</td>
                <td>{{row.typeOfRight}}</td>
                <td>{{row.territory}}</td>
                <td>{{row.licensor}}</td>
                <td>{{row.programCode}}</td>
                <td>{{row.performanceQuarter}}</td>
                <td>{{row.countryName}}</td>
                <td>{{row.fileType}}</td>
                <td>{{row.licensorCode}}</td>
                <td>{{row.revenueClassCode}}</td>
                <td>{{row.revenueClassDescription}}</td>
                <td>{{row.adjustentDistributionDate | date}}</td>
                <td>{{row.currentActivityAmt}}</td>
                <td>{{row.hitSongBonus}}</td>
                <td>{{row.standardsBonus}}</td>
                <td>{{row.foreignSocietyAdjustment}}</td>
                <td>{{row.perfDate | date}}</td>
                <td>{{row.wOrP}}</td>
                <td>{{row.showName}}</td>
                <td>{{row.paymentType}}</td>
                <td>{{row.chart}}</td>
                <td>{{row.position}}</td>
                <td>{{row.payNumber}}</td>
                <td>{{row.synd}}</td>
                <td>{{row.strip}}</td>
                <td>{{row.performance}}</td>
                <td>{{row.occur}}</td>
                <td>{{row.socidetyAbbrv}}</td>
                <td>{{row.societyCountry}}</td>
            </tr>
        </table>
    </div>
    <app-custom-scroll-bar [scrollContainer]="scrollContainerRef.nativeElement" *ngIf="allPartnerPros.length > 0"></app-custom-scroll-bar>

    <app-custom-pagination *ngIf="allPartnerPros.length > 0" [data]="tableData"></app-custom-pagination>
</div>
<!-- STANDARD HTML TABLE APPROACH - END --> 